import React from "react";
import "./ReadingMask.css";
const ReadingMask = ({ mousePosition = 0 }) => {
    return (React.createElement("div", { className: "reading-mask-parent", style: {
            width: `${document.body.offsetWidth}px !important`,
        } },
        React.createElement("div", { className: "reading-mask", style: {
                zIndex: "2147483647 !important",
                width: "100vw !important",
                top: "0px",
                height: `${mousePosition - 50}px`,
            } }),
        React.createElement("div", { className: "reading-mask", style: {
                zIndex: "2147483647 !important",
                width: "100vw !important",
                height: `${document.body.offsetHeight - mousePosition}px`,
                marginTop: "100px",
                top: `${mousePosition - 50}px`,
            } })));
};
export default ReadingMask;
//# sourceMappingURL=ReadingMask.js.map